import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';


import { Helmet } from 'react-helmet';
import getCookie from '../../../helper/getCookie';
import LoadingScreen from '../../components/LoadingScreen';
import getDecryptData from '../../../helper/getDecryptData';
import { useBlogContext } from '../../../fetchdata/BlogContext';

const AccountAllMedical = () => {
  const { Headers, isHeader } = useBlogContext();

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchData = async () => {
    const decryptdatajson = await getDecryptData();
    const userId = decryptdatajson?._id;
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/all-medical?page=${currentPage}&limit=${limit}&search=${searchTerm}&type=3&userId=${userId}`);
      setData(response.data.Order || []);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      console.log(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, limit]);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };




  const inputRef = React.createRef();

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setTotalPages(1)
    setSearchTerm(e.target.value);


  };

  const handleSearch = () => {
    fetchData(currentPage);

  };


  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      month: 'long', // Use 'long' to display the full month name
      day: 'numeric',
      year: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // hour12: true
    };
    return date.toLocaleString('en-US', options);
  };

const formatDateTile = (timestamp) => {
  const date = new Date(timestamp);

  return {
    day: date.getDate(), // 18
    month: date.toLocaleString('en-US', { month: 'short' }),
    year: date.getFullYear() // 2021
  };
};
  
    const handleStatusChange = (ratingId) => async (event) => {
      const newStatus = event.target.value;
      setLoading(true);
  
      try {
        await axiosInstance.put(`/admin/update-order/${ratingId}`, { status: newStatus });
        setLoading(false);
        fetchData(currentPage);
        toast.success("Status Updated success!");
      } catch (error) {
        console.error('Error updating rating status:', error);
        setLoading(false);
      }
  
    };

  return (
    <>

      <Header />

      <Helmet>
        <title> Account Order | {window.location.hostname}</title>

      </Helmet>



      <div className="user-dasboard whitesmoke" >

        <div className="container pt-4">
          <div className="row pb-4">

            <AccountSidebar />

            <div className="col-lg-9 my-lg-0 my-1">
              <div id="main-content" className="bg-white border">



                {loading ? <LoadingScreen />
                  :
                  <div className="card bg-transparent border-0 mb-4">


                    <div className="row">


                      <div className="datatable-top d-flex align-items-center justify-content-between w-100 border-bottom pb-3">
                        <h4 className="text-uppercase h5 ">All Medical</h4>

                        <div className="datatable-dropdown">
                          <label className='d-flex align-items-center gap-2'>
                            <select className="form-control w-auto" value={limit} onChange={(e) => {
                              setlimit(parseInt(e.target.value, 10));
                              setCurrentPage(1); // Reset current page to 1 when the limit changes
                            }} >
                              <option value={5}>5</option>
                              <option value={10} >
                                10
                              </option>
                              <option value={15}>15</option>
                              <option value={20}>20</option>
                              <option value={25}>25</option>
                            </select>{" "}

                            entries per page
                          </label>
                        </div>

                      </div>




                     {data.map((row, index) => (
                      <>
                      
 <div key={row.index} className="card border shadow-sm mt-4 bg-light">
    <div className="card-body py-3">
      <div className="row align-items-center g-3">
        {/* Date tile */}
        <div className="col-auto">
          <div className="border rounded-2 text-center px-3 py-2 bg-white"> 
            <div className="fw-bold fs-3 lh-1">  {formatDateTile(row.PickupDate).day} </div>
            <div className="text-uppercase text-muted small lh-1 mt-1"> {formatDateTile(row.PickupDate).month}</div>
              <div className="text-uppercase text-muted small lh-1 mt-1"> {formatDateTile(row.PickupDate).year}</div>

            
          </div>
        </div>
        {/* Main text */}
        <div className="col">
          <div className="d-flex align-items-start flex-column flex-sm-row">
            <div className="me-sm-2">
              <div className="fw-semibold">
               <span className={`badge bg-${
    row.status === 0 ? 'secondary' :
    row.status === 1 ? 'primary' :
    row.status === 2 ? 'success' :
    row.status === 3 ? 'warning' :
    row.status === 4 ? 'info' :
    row.status === 5 ? 'danger' : 'dark'
  }`}>
    {
      row.status === 0 ? 'Booked' :
      row.status === 1 ? 'Assigned' :
      row.status === 2 ? 'Delivered to client' :
      row.status === 3 ? 'Return to runner' :
      row.status === 4 ? 'Received in store' :
      row.status === 5 ? 'Cancel ' :
      'Unknown'
    }
  </span> Consulted Dr. {row.employeeId?.username} for {row.employeeId?.department?.name ?? 'NA'}
              </div>
              <div className="text-muted small">Records for {row?.UserDetails[0]?.name ?? 'Unkown'}</div>
            </div>
          </div>
        </div>
        {/* Right meta + kebab */}
        <div className="col-auto ms-auto d-flex align-items-center gap-3">
          <div className="text-muted small">{row?.prescription.length} Prescription {row?.images.length !==0 && `, ${row?.images.length} Images`} </div>
          {/* Kebab dropdown */}
          <div className="dropdown">
            <button
              className="btn btn-link text-muted p-0 border-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fs-5">⋮</span>
            </button>
            <ul className="dropdown-menu dropdown-menu-end pb-0">
              {/* <li>
                <Link className="dropdown-item" to={`/account/medical/${row._id}`}>
                  View
                </Link>
              </li>
              <li>
           <a href={`${weburl}user-invoice/${row._id}`} target="_blank" className="dropdown-item">  Invoice </a>
            
              </li>
              
              <li>
                <hr className="dropdown-divider pb-0 mb-0" />
              </li>
              <li className='bg-light p-2'>
                  <select disabled={row.status === 5} className={`form-control select text-center ${row.status === 5 && 'bg-danger text-white'}`} value={row.status} name="status" onChange={handleStatusChange(row._id)}> 
                            <option selected>Select Status</option>
                       
                            <option value="5">Cancel Order</option>
 
                           </select>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
 
  </>
                       
                          ))}


                      <div className='container mt-4'>
                        <div className='d-flex bg-light border  align-center p-2 mx-auto overflow-hidden justify-content-between' style={{ maxWidth: '500px', borderRadius: '40px' }}>
                          <button href="/hospital/67973150a76a66c3198c5060" onClick={handlePreviousPage} disabled={loading || currentPage === 1} className="btn btn-white btn-shadow d-block border " style={{ borderRadius: '40px' }} >Previous</button>
                          <div className='col align-items-center d-flex justify-content-center'>
                            <span>   Showing  {currentPage} of {totalPages} </span>
                          </div>
                          <button className="btn btn-white btn-shadow d-block border" style={{ borderRadius: '40px' }} onClick={handleNextPage} disabled={loading || currentPage === totalPages} >Next</button>

                        </div>
                      </div>


                    </div>
                  </div>
                }

              </div>
            </div>
          </div>
        </div>

      </div>



      <Footer />


    </>
  )
}

export default AccountAllMedical